import React, { useState, useEffect, useCallback } from 'react';

const CountdownTimer = ({ 
  initialMinutes = 15, 
  onComplete, 
  isRunning = true,
  format = 'MM:SS' // MM:SS or MMm SSs
}) => {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60); // Convert to seconds
  const [isActive, setIsActive] = useState(isRunning);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (format === 'MM:SS') {
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    } else {
      return `${mins}m ${secs}s`;
    }
 };

  const resetTimer = useCallback(() => {
    setTimeLeft(initialMinutes * 60);
    setIsActive(true);
  }, [initialMinutes]);

  const pauseTimer = useCallback(() => {
    setIsActive(false);
 }, []);

  const resumeTimer = useCallback(() => {
    setIsActive(true);
 }, []);

  useEffect(() => {
    let interval = null;

    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft(time => time - 1);
      }, 100);
    } else if (timeLeft === 0) {
      onComplete && onComplete();
      setIsActive(false);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, timeLeft, onComplete]);

  const minutesLeft = Math.floor(timeLeft / 60);
  const secondsLeft = timeLeft % 60;
  const isExpiringSoon = minutesLeft === 0 && secondsLeft <= 30;

  return (
    <div className="flex items-center justify-center space-x-2">
      <span className={`text-sm font-medium ${isExpiringSoon ? 'text-red-600 animate-pulse' : 'text-muted-foreground'}`}>
        Expires in: {formatTime(timeLeft)}
      </span>
    </div>
  );
};

export default CountdownTimer;
